// extracted by mini-css-extract-plugin
module.exports = {"Rinkeby":"Rinkeby_Rinkeby__1rdfV"};